import { Component } from '@angular/core';

@Component({
	selector: 'app-tourism-events',
	templateUrl: './tourism-events.component.html',
	styleUrls: ['./tourism-events.component.css'],
})
export class TourismEventsComponent {}
